<template>
  <div class="pc-insert-image-item">
    <div class="container" :class="{selected: selected}" @click="clickHandler">
      <div class="selected-icon">
        <i class="el-icon-check"></i>
      </div>
      <div class="image-area">
        <img :src="src"/>
      </div>
      <div class="summary">
        <div>{{name}}</div>
        <div>{{size}} {{time}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InsertImageItem',
  props: ['data', 'selected'],
  computed: {
    src () {
      return `${this.data.src}`
    },
    name () {
      return this.data.name
    },
    time () {
      return this.data.createdTime
    },
    size () {
      return this.data.size
    }
  },
  methods: {
    clickHandler () {
      this.$emit('select', this.data.md5)
    }
  }
}
</script>

<style lang="scss">
@import '@/assets/variables.scss';
.pc-insert-image-item {
  .container {
    position: relative;
    height: 0;
    padding-bottom: 70%;
    border: 1px solid $border-color-structure;
    cursor: pointer;

    &.selected {
      border-color: $color-main;
    }

    .selected-icon {
      width: 1.6rem;
      height: 1.6rem;
      background: $color-main;
      position: absolute;
      right: 0;
      top: 0;
      color: white;
      font-weight: bold;
      text-align: center;
      line-height: 1.6rem;
      display: none;
    }

    &.selected .selected-icon {
      display: block;
    }
  }
  .image-area {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  img {
    max-width: 100%;
    max-height: 100%;
  }

  .summary {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba($color: #000000, $alpha: .4);
    padding: .5rem;
    opacity: 0;
    color: white;
    transition: opacity .5s;
  }

  &:hover .summary {
    opacity: 1;
  }

}
</style>
